"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var OnboardComponent_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//VARIABLE MODELS
const onboard_service_1 = require("./onboard.service");
const forms_1 = require("@angular/forms");
let OnboardComponent = OnboardComponent_1 = class OnboardComponent {
    constructor(_Onboard, _fb) {
        this._Onboard = _Onboard;
        this._fb = _fb;
        this.inventory = {
            display: false,
            video: false,
            CTV: false,
        };
        this.submitted = false;
        this.adServerList = [
            { key: "AD_MANAGER", value: "Ad Manager" },
            { key: "ADMOB", value: "Ad Mob" }
        ];
        this.monthlyAdRequestsList = [
            "Less than 100,000",
            "100,000 - 500,000",
            "500,000 - 1 Million",
            "1 Million - 10 Million",
            "10 Million - 100 Million",
            "100 Million - 500 Million",
            "500 Million - 1 Billion",
            "> 1 Billion",
        ];
        this.inventoryRelationshipList = [
            "Owned & Operation",
            "Intermediary",
            "Both",
        ];
        this.testMode = false;
        this.success = false;
        this.createOnboardFrom();
    }
    isOriginValid(origin) {
        if (this.testMode) {
            return origin == this.trustedTestOrigin;
        }
        else {
            return OnboardComponent_1.validOrigins.includes(origin);
        }
    }
    ngOnInit() {
        this.token = (Math.random() + 1).toString(36).substring(2);
        this.sourceWindow = window.opener;
        if (!document.referrer) {
            console.log("Valid referrer not found");
            return;
        }
        this.referrerOrigin = (new URL(document.referrer)).origin;
        console.log("sending request for datapoint");
        this.sourceWindow.postMessage({
            "version": "v2",
            "token": this.token,
            "type": "DATA_POINTS_REQUEST"
        }, this.referrerOrigin);
    }
    createOnboardFrom() {
        let emailRegx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
        let domainRegx = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
        this.onboardForm = this._fb.group({
            firstName: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            lastName: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            email: ["", [forms_1.Validators.required, this.noWhitespaceValidator, forms_1.Validators.pattern(emailRegx)]],
            phone: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            company: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            website: ["", [forms_1.Validators.required, this.noWhitespaceValidator, forms_1.Validators.pattern(domainRegx)]],
            address1: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            address2: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            state: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            postalCode: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            country: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            adServer: [
                "Ad Manager",
                [forms_1.Validators.required, this.noWhitespaceValidator],
            ],
            googlePubId: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            crawlUrl: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            inventory: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            monthlyAdRequests: [
                "Less than 100,000",
                [forms_1.Validators.required, this.noWhitespaceValidator],
            ],
            inventoryRelationship: [
                "Owned & Operation",
                [forms_1.Validators.required, this.noWhitespaceValidator],
            ],
            domains: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            publisherName: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            // signature : ['',[Validators.required,this.noWhitespaceValidator]],
            name: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            title: ["", [forms_1.Validators.required, this.noWhitespaceValidator]],
            date: [this.getDate(), [forms_1.Validators.required, this.noWhitespaceValidator]],
        });
    }
    get registerFormControl() {
        return this.onboardForm.controls;
    }
    noWhitespaceValidator(control) {
        const isWhitespace = (control.value ? control.value.toString() : "").trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { whitespace: true };
    }
    getDate() {
        var today = new Date();
        return (today.getFullYear() +
            "-" +
            ("0" + (today.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + today.getDate()).slice(-2));
    }
    setInvetoryType() {
        this.onboardForm.value.inventory = "";
        let value = "";
        Object.keys(this.inventory).forEach((key) => {
            if (this.inventory[key]) {
                if (this.onboardForm.value.inventory) {
                    value = this.onboardForm.value.inventory + "," + key;
                }
                else {
                    value = key;
                }
            }
        });
        this.onboardForm.patchValue({ inventory: value });
    }
    onMessage(event) {
        console.log(event);
        if (this.isOriginValid(event.origin) && event.origin == this.referrerOrigin) {
            this.jsonData = event.data;
            var messageType = this.jsonData["type"];
            if (messageType == "DATA_POINTS") {
                this.processDataPoints();
            }
            else if (messageType == "ACK") {
                this.processAcknowledgement();
            }
            else if (messageType == "TEST") {
                this.processTest();
            }
        }
        else {
            console.error("invalid origin: " + this.referrerOrigin);
        }
    }
    beforeunloadHandler(event) {
        if (!this.success) {
            this.sendResult("CANCEL");
        }
    }
    processDataPoints() {
        if ((this.jsonData["origin-product"] == "ADMOB" || this.jsonData["origin-product"] == "AD_MANAGER")
            && /^pub-[a-zA-Z0-9]+$/.test(this.jsonData["publisher-id"])
            && this.jsonData["token"] == this.token) {
            console.log("setting data points");
            this.onboardForm.patchValue({ adServer: this.jsonData["origin-product"] });
            this.onboardForm.patchValue({ googlePubId: this.jsonData["publisher-id"] });
            this.sendAcknowledgement("DATA_POINTS");
        }
    }
    processAcknowledgement() {
        if (this.jsonData["ack-type"] == "RESULT") {
            console.log("Success ack received from goole - clearing timeout of redirection and closing window");
            clearTimeout(this.waitForAck);
            if (this.success) {
                setTimeout(() => window.close(), 5000);
            }
        }
    }
    processTest() {
        if (this.jsonData["test-directive"] == "START") {
            if (this.jsonData["test-origin"].endsWith("zipline.appspot.com")) {
                console.log("Trusting test-origin and setting testmode to true");
                this.trustedTestOrigin = this.jsonData["test-origin"];
                this.testMode = true;
            }
        }
        else if (this.jsonData["test-directive"] == "NEXT") {
            // Either advance to next step in the bidder workflow
            // this.sourceWindow.postMessage({
            // 	"version": "v2",
            // 	"token": this.token,
            // 	"type": "ACK",
            // 	"ack-type": "TEST_NEXT",
            // }, this.referrerOrigin);
            // Or send the result to terminate the test
            this.sourceWindow.postMessage({
                "version": "v2",
                "token": this.token,
                "type": "RESULT",
                "origin-product": this.jsonData["origin-product"],
                "publisher-id": this.jsonData["publisher-id"],
                "result-value": "SUCCESS"
            }, this.referrerOrigin);
        }
    }
    sendAcknowledgement(ackType) {
        console.log("Sending acknowledgement of :", ackType);
        this.sourceWindow.postMessage({
            "version": "v2",
            "token": this.token,
            "type": "ACK",
            "ack-type": ackType,
            "origin-product": this.jsonData["origin-product"],
            "publisher-id": this.jsonData["publisher-id"]
        }, this.referrerOrigin);
    }
    sendResult(result, details) {
        console.log("Sending result for : ", result);
        let msg = {
            "version": "v2",
            "token": this.token,
            "type": "RESULT",
            "origin-product": this.jsonData["origin-product"],
            "publisher-id": this.jsonData["publisher-id"],
            "result-value": result,
            "keep-window-open": true,
        };
        if (result === "ERROR") {
            msg["result-value"] = result;
            msg["result-details"] = details;
        }
        this.sourceWindow.postMessage(msg, this.referrerOrigin);
    }
    cancelApplication() {
        console.log("User has cancelled form");
        window.location.href = this.jsonData["redirect-url"];
    }
    submitApplication() {
        console.log("User has submitted form:", this.onboardForm);
        this.submitted = true;
        if (this.onboardForm.valid) {
            this.onboardForm.value.crawlUrl = this.onboardForm.value.crawlUrl
                .split(" ")
                .join(",");
            this.onboardForm.value.crawlUrl = this.onboardForm.value.crawlUrl
                .split("\n")
                .join(",");
            this.onboardForm.value.domains = this.onboardForm.value.domains
                .split(" ")
                .join(",");
            this.onboardForm.value.domains = this.onboardForm.value.domains
                .split("\n")
                .join(",");
            Promise.resolve(this._Onboard.submitApplication(this.onboardForm.value))
                .then(res => {
                console.log("Application submitted successfully");
                if (document.referrer) {
                    this.success = true;
                    this.sendResult("SUCCESS");
                    this.waitForAck = setTimeout(() => window.location.href = this.jsonData["redirect-url"], 500);
                }
            })
                .catch(err => {
                console.log("Error while submitting application:", err);
                this.sendResult("ERROR", err);
            });
        }
    }
};
exports.OnboardComponent = OnboardComponent;
OnboardComponent.validOrigins = [
    "https://admanager.google.com",
    "https://apps.admob.com",
    "https://admanager-ics.corp.google.com",
    "https://admanager-qalive.qa.adz.google.com",
    "https://ics.corp.google.com",
    "https://zipline.appspot.com",
    "http://localhost:8080"
];
__decorate([
    (0, core_1.HostListener)('window:message', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], OnboardComponent.prototype, "onMessage", null);
__decorate([
    (0, core_1.HostListener)('window:beforeunload', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], OnboardComponent.prototype, "beforeunloadHandler", null);
exports.OnboardComponent = OnboardComponent = OnboardComponent_1 = __decorate([
    (0, core_1.Component)({
        selector: "my-onboard",
        templateUrl: "app/onboard.component.html",
        styleUrls: ["styles/onboard.component.css"],
    }),
    __metadata("design:paramtypes", [onboard_service_1.OnboardService,
        forms_1.FormBuilder])
], OnboardComponent);
//# sourceMappingURL=onboard.component.js.map